import { Link } from '@achieve/ascend'
import { Typography } from 'components/Typography'
import React from 'react'
import { numberFormatCurrency } from 'constants/DebtAssessment'
import HourGlass from 'components/Svgs/HourGlass'
import { Image } from 'components/Image'

const generateDebtSummary = (
  beginningLine,
  totalDebt,
  moreEachMonth,
  moreMonthsToBeDebtFree,
  endingLine,
  showWaitTime,
  variation
) => {
  return [
    variation == 'bars' ? (
      <React.Fragment key="totalDebt">
        {beginningLine} <span>{numberFormatCurrency(totalDebt)} more in total debt</span>
      </React.Fragment>
    ) : (
      <React.Fragment key="totalDebt">
        {beginningLine} <span>{numberFormatCurrency(totalDebt)} more </span>in total debt,
      </React.Fragment>
    ),
    !showWaitTime && ' and',
    <React.Fragment key="moreEachMonth">
      <span> {numberFormatCurrency(moreEachMonth)} more each month</span>
    </React.Fragment>,
    showWaitTime && (
      <React.Fragment key="moreMonthsToBeDebtFree">
        , and take <span>{moreMonthsToBeDebtFree} months longer</span>
      </React.Fragment>
    ),
    ` ${endingLine}`,
  ]
}

export const DatWait = ({
  title = "Don't Wait!",
  beginningLine = 'If you wait 3 months, you are estimated to pay',
  endingLine = 'to get rid of your debt.',
  totalDebt = 2300,
  moreEachMonth = 57,
  moreMonthsToBeDebtFree = 4,
  linkHref = '/',
  linkText = 'Explore debt solutions',
  showWaitTime = true,
  onClick,
  variation = 'line',
}) => {
  const debtSummary = generateDebtSummary(
    beginningLine,
    totalDebt,
    moreEachMonth,
    moreMonthsToBeDebtFree,
    endingLine,
    showWaitTime,
    variation
  )
  const linkTrackObject = {
    click_id: linkText,
    click_text: `Achieve-Web | ${linkText}`,
    click_url: linkHref,
  }
  return (
    <div
      className={
        variation == 'bars'
          ? 'flex flex-col lg:px-6 py-[2px] gap-2  lg:pl-4 lg:pr-4 my-3 lg:m-10 lg:max-w-[490px]'
          : 'flex flex-col border-l-[3px] border-t-0 border-b-0 border-r-0 border-solid border-l-[rgb(207,38,78)] px-6 py-[2px] gap-2  lg:pl-6 lg:pr-6 lg:ml-[60px] my-5 lg:m-12'
      }
    >
      <div className="flex items-center">
        {variation == 'bars' ? (
          <Image
            alt="Wait"
            height={20}
            fetchPriority="high"
            preload={1}
            className="mr-3"
            src="/SandGlass.svg"
            width={12}
          />
        ) : (
          <HourGlass className="mr-4" variation={variation} />
        )}
        <Typography
          variant="bodyLg"
          data-testid="dat-wait-title"
          className={
            variation == 'bars' ? 'text-[#42546B] font-medium' : 'text-[rgb(207,38,78)] font-bold'
          }
        >
          {title}
        </Typography>
      </div>
      <Typography
        variant="labelSm"
        data-testid="dat-wait-paragraph"
        className={
          variation == 'bars'
            ? 'text-[#5C708A] [&>span]:text-[#CF264E] font-normal [&>span]:font-medium'
            : 'text-gray-700 [&>span]:font-bold'
        }
      >
        {debtSummary}
      </Typography>
      <Link
        onClick={onClick && (() => onClick(linkTrackObject))}
        fontWeight="medium"
        underline="always"
        variant="labelSm"
        href={linkHref}
        data-testid="dat-wait-link"
      >
        {linkText}
      </Link>
    </div>
  )
}
